import { Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { NoAuthGuard } from '@guards/no-auth.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'perfil/admin', pathMatch: 'full' }, //* Redirección al área autenticada.
    {
        path: 'auth',
        canActivate: [NoAuthGuard],
        loadChildren: () => import('./auth/auth.routes').then(r => r.AuthRoutes)
    },
    /* GENERAL */
    {
        path: 'perfil',
        title: 'SYMAPF | Perfil',
        canActivate: [AuthGuard],
        loadChildren: () => import('./profile/profile.routes').then(r => r.ProfileRoutes),
    },
    /* SUPERADMIN */
    {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () => import('./superadmin/superadmin.routes').then(r => r.SuperAdminRoutes)
    },
    /* SYSPOL */
    {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () => import('./syspol/syspol.routes').then(r => r.SyspolRoutes)
    },
    { path: '**', redirectTo: 'auth/login' } //* Redirección a la página de autenticación.
];